export default {"src":"/_next/static/media/boots.59c97a3c.svg","height":168,"width":178,"blurWidth":0,"blurHeight":0};